import script from "./CommandQueueOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./CommandQueueOverlay.vue?vue&type=script&setup=true&lang=js"

import "./CommandQueueOverlay.vue?vue&type=style&index=0&id=98382826&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98382826"]])

export default __exports__